import { FC } from 'react';

import { Box } from '@mui/material';
import { SxStyles } from 'types';

const styles: SxStyles = {
  position: 'absolute',
  top: 0,
  right: '72px',

  display: 'flex',

  padding: '12px',
  borderRadius: '0 0 12px 12px',
  backgroundColor: '#FFF3BFE5',
};

const imageStyles: SxStyles = {
  width: '48px',
  height: '48px',
};

interface IAchievementProps {
  image: string;
}

const Achievement: FC<IAchievementProps> = ({ image }) => {
  return (
    <Box className="achievement" sx={styles}>
      <Box component="img" src={image} sx={imageStyles} />
    </Box>
  );
};

export default Achievement;
